<template>
    <div>
        <div v-if="!currentUser.isAdmin || currentUser.id === user.id" class="alert alert-warning">
            <p>Только администраторы могут изменять роли и права доступа пользовалей. Если вы считаете, что у вас должно быть больше прав, пожалуйста напишите на почту <a href="mailto:anton@alarm.ru">anton@alarm.ru</a> с просьбой предоставить доступ.</p>
            <p>
                В дальнейшем руководители в компаниях и техцентрах смогут управлять пользователями и их правами в рамках своего техцентра. Данный функционал пока в разработке, по всем вопросам просьба писать на <a href="mailto:anton@alarm.ru">anton@alarm.ru</a>.
            </p>
        </div>
        <template v-else>
            <loading v-if="loadingRoles" :size="2" message="Загружаем роли..."></loading>
            <div v-else class="card">
                <div class="card-header">
                    Роли пользователя
                </div>
                <div class="card-block">
                    <div class="row mb-1">
                        <div class="col-12 col-md-6 col-lg-3" v-for="role in roles">
                            <div class="row  mb-2">
                                <div class="col-8">{{role.description}}</div>
                                <div class="col-4">
                                    <loading v-if="rolesChanges.indexOf(role.id) !== -1" :size="2" :message="false"></loading>
                                    <label v-else class="switch switch-lg switch-3d switch-primary">
                                        <input
                                                :value="user.hasRole(role.name)"
                                                :checked="user.hasRole(role.name)"
                                                @change="updateUserRole(user.hasRole(role.name), role.id)"
                                                type="checkbox"
                                                class="switch-input"
                                        >
                                        <span class="switch-label"></span>
                                        <span class="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row  mb-2">
                        <div class="col-8">
                            Персональные права доступа для пользователя <br>
                            <span class="text-warning small">При активации все доступные роли пользователя будут деактивированы. Необходимо будет вручную настроить права доступа</span>
                        </div>
                        <div class="col-4">
                            <loading v-if="rolesChanges.indexOf('personal') !== -1" :size="2" :message="false"></loading>
                            <label v-else-if="user.roles.length === 0"
                                   class="switch switch-lg switch-3d switch-primary"
                                   v-b-tooltip.hover.auto title="Для отключения персональных прав доступа активируйте одну из ролей"
                            >
                                <input
                                        :value="user.roles.length === 0"
                                        :checked="user.roles.length === 0"
                                        type="checkbox"
                                        class="switch-input disabled"
                                        disabled
                                >
                                <span class="switch-label"></span>
                                <span class="switch-handle"></span>
                            </label>
                            <label v-else class="switch switch-lg switch-3d switch-primary">
                                <input
                                        :value="user.roles.length === 0"
                                        :checked="user.roles.length === 0"
                                        @change="clearUserRole()"
                                        type="checkbox"
                                        class="switch-input"
                                >
                                <span class="switch-label"></span>
                                <span class="switch-handle"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <loading v-if="loadingPermissions" :size="2" message="Загружаем права доступа..."></loading>
            <div v-else>
                <div v-if="user.roles.length !== 0" class="alert alert-warning">
                    Права доступа отображаются из совокупности ролей, вы можете активировать персональные права доступа для этого пользователя, если выставите соответсующий переключатель в разделе роли
                </div>
                <div class="card" v-for="group in getPermissionsGroups()">
                    <div class="card-header">
                        {{getPermissionsGroupName(group)}}
                    </div>
                    <div class="card-block">
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-3" v-for="permission in getPermissionsByGroupName(group)">
                                <div class="row  mb-2">
                                    <div class="col-8">{{permission.description}}</div>
                                    <div class="col-4">
                                        <loading v-if="permissionChanges.indexOf(permission.id) !== -1" :size="2" :message="false"></loading>
                                        <label v-else-if="user.roles.length === 0" class="switch switch-lg switch-3d switch-primary">
                                            <input
                                                    :value="user.hasPermission(permission.name)"
                                                    :checked="user.hasPermission(permission.name)"
                                                    type="checkbox"
                                                    @change="updateUserPermission(user.hasPermission(permission.name), permission.id)"
                                                    class="switch-input"
                                            >
                                            <span class="switch-label"></span>
                                            <span class="switch-handle"></span>
                                            <small v-if="user.hasPermission(permission.name)">разрешено</small>
                                            <small v-else>запрещено</small>
                                        </label>
                                        <label v-else-if="currentUser.hasPermission(permission.name)"
                                               class="switch switch-lg switch-3d switch-primary"
                                               v-b-tooltip.hover.auto title="Для активации отдельных разрешений переключите использование идивидуальных прав доступа в разделе роли"
                                        >
                                            <input
                                                    :value="user.hasPermission(permission.name)"
                                                    :checked="user.hasPermission(permission.name)"
                                                    type="checkbox"
                                                    class="switch-input disabled"
                                                    disabled
                                            >
                                            <span class="switch-label"></span>
                                            <span class="switch-handle"></span>
                                            <small v-if="user.hasPermission(permission.name)">разрешено</small>
                                            <small v-else>запрещено</small>
                                        </label>
                                        <label v-else
                                               class="switch switch-lg switch-3d switch-primary"
                                               v-b-tooltip.hover.auto title="Вы не можете разрешить данное действие пользователю, т.к. сами не имеете доступа к данным правам"
                                        >
                                            <input
                                                    :value="user.hasPermission(permission.name)"
                                                    :checked="user.hasPermission(permission.name)"
                                                    type="checkbox"
                                                    class="switch-input disabled"
                                                    disabled
                                            >
                                            <span class="switch-label"></span>
                                            <span class="switch-handle"></span>
                                            <small v-if="user.hasPermission(permission.name)">разрешено</small>
                                            <small v-else>запрещено</small>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import getRoles from './../../gql/queries/Acl/getRoles.graphql'
  import getPermissions from './../../gql/queries/Acl/getPermissions.graphql'
  import updateUserRole from './../../gql/mutations/Acl/UpdateUserRole.graphql'
  import clearUserRoles from './../../gql/mutations/Acl/ClearUserRoles.graphql'
  import updateUserPermission from './../../gql/mutations/Acl/UpdateUserPermission.graphql'
  export default {
    props: ['userId'],
    computed: {
      ...mapState({
        user: state => state.userStore.user,
        currentUser: state => state.globalStore.user
      })
    },
    data () {
      return {
        roles: [],
        permissions: [],
        loadingRoles: false,
        loadingPermissions: false,
        rolesChanges: [],
        permissionChanges: []
      }
    },
    methods: {
      getPermissionsGroups () {
        let groups = this.permissions.map(function (item) {
          let arr = item.name.split('.')
          return arr[0]
        }).filter(function (value, index, self) {
          return self.indexOf(value) === index
        })
        return groups
      },
      getPermissionsGroupName (code) {
        switch (code) {
          case 'order':
            return 'Заказы'
          case 'comments':
            return 'Комментарии'
          case 'role':
            return 'Роли пользователей'
          case 'permission':
            return 'Разрешения'
          case 'user':
            return 'Пользователи'
          case 'company':
            return 'Компании'
          case 'city':
            return 'Города'
          case 'pbx':
            return 'Телефония'
          case 'techcenter':
            return 'Техцентры'
          default:
            return code
        }
      },
      getPermissionsByGroupName (group) {
        let permissions = this.permissions.filter(function (item) {
          let arr = item.name.split('.')
          return arr[0] === group
        })
        return permissions
      },
      updateUserRole (oldValue, roleId) {
        this.rolesChanges.push(roleId)
        this.$apollo.mutate({
          mutation: updateUserRole,
          variables: {
            userId: this.userId,
            roleId: roleId,
            value: !oldValue
          }
        }).then((result) => {
          this.$store.commit('UPDATE_VIEWED_USER', result.data.updateUserRole)
          this.addToast({
            text: 'Настройки успешно обновлены',
            type: 'success',
            dismissAfter: 3000
          })
          this.rolesChanges.splice(this.rolesChanges.indexOf(roleId), 1)
        }).catch((error) => {
          this.rolesChanges.splice(this.rolesChanges.indexOf(roleId), 1)
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка при сохраннеии настроек: ' + error,
            type: 'danger',
            dismissAfter: 10000
          })
        })
      },
      updateUserPermission (oldValue, permissionId) {
        this.permissionChanges.push(permissionId)
        this.$apollo.mutate({
          mutation: updateUserPermission,
          variables: {
            userId: this.userId,
            permissionId: permissionId,
            value: !oldValue
          }
        }).then((result) => {
          this.$store.commit('UPDATE_VIEWED_USER', result.data.updateUserPermission)
          this.addToast({
            text: 'Настройки успешно обновлены',
            type: 'success',
            dismissAfter: 3000
          })
          this.permissionChanges.splice(this.permissionChanges.indexOf(permissionId), 1)
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка при сохраннеии настроек: ' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.permissionChanges.splice(this.permissionChanges.indexOf(permissionId), 1)
        })
      },
      clearUserRole (index) {
        this.rolesChanges.push('personal')
        this.$apollo.mutate({
          mutation: clearUserRoles,
          variables: {
            userId: this.userId
          }
        }).then((result) => {
          this.$store.commit('UPDATE_VIEWED_USER', result.data.clearUserRoles)
          this.addToast({
            text: 'Настройки успешно обновлены',
            type: 'success',
            dismissAfter: 3000
          })
          this.rolesChanges.splice(this.rolesChanges.indexOf('personal'), 1)
        }).catch((error) => {
          this.addToast({
            text: 'Произошла ошибка при сохраннеии настроек: ' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.rolesChanges.splice(this.rolesChanges.indexOf('personal'), 1)
        })
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    apollo: {
      roles: {
        query: getRoles,
        variables: {
          all: true
        },
        update: (data) => {
          return data.roles
        },
        watchLoading (isLoading, countModifier) {
          this.loadingRoles = isLoading
        }
      },
      permissions: {
        query: getPermissions,
        update: (data) => {
          return data.permissions
        },
        watchLoading (isLoading, countModifier) {
          this.loadingPermissions = isLoading
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Permissions.vue?7ba94392